import { get } from "./HttpClient";
import { API_GET_CMS_FAQS, API_GET_CMS_PAGES } from "./ApisRoutes";

// CMS-backed static content (about us, press, vacancies, legal pages, FAQs).
//
// Every consumer previously called raw axios and hand-rolled its own
// Authorization header, bypassing the HttpClient interceptors that already
// attach the token and track loading state. Centralised here so the request
// shape — and the X-Locale header the CMS uses to pick a translation — is
// defined once.

const localeHeaders = (language) => ({
    headers: { "X-Locale": language?.short?.toLowerCase() },
});

/**
 * Fetch a single CMS page by its type slug.
 * @param {string} type e.g. "about_us", "privacy_policy", "cookie_policy"
 * @param {object} language the locale object from redux (uses `.short`)
 * @returns {Promise<object|undefined>} the first page entry, or undefined
 */
export const GetStaticPageContent = async (type, language) => {
    const response = await get(
        `${API_GET_CMS_PAGES}?type=${encodeURIComponent(type)}`,
        null,
        localeHeaders(language)
    );
    return response?.data?.data?.[0];
};

/**
 * Fetch the FAQ list.
 * @param {object} language the locale object from redux (uses `.short`)
 * @returns {Promise<Array>} FAQ entries, empty when none are returned
 */
export const GetFaqsContent = async (language) => {
    const response = await get(API_GET_CMS_FAQS, null, localeHeaders(language));
    return response?.data?.data || [];
};
